export default __webpack_public_path__ + "static/media/gyms mockup.b43846ff.png";